import React, { useState } from 'react';
import { formatTalleres } from '../../../utils';
import styles from '../../../styles/shared/Checklist.module.css';
import { formatDate, formatTime } from '../../../utils/date';

const StoreroomRequestChecklist = ({ mostrarCheckList, setMostrarCheckList, solicitud, procesarPedido }) => {
    const [isCommenting, setIsCommenting] = useState(false);
    const [comment, setComment] = useState(' ');
    const [actionType, setActionType] = useState(null); 

  const handleAction = (type) => {
        setActionType(type);
        setIsCommenting(true);
    };

    const submitComment = () => {
        procesarPedido(solicitud.id, actionType === 'accept' ? 'En proceso' : 'Rechazado', comment);
        setMostrarCheckList(false); 
    };


    if (!mostrarCheckList || !solicitud) {
        return null;
    }

     return (
        <div className={styles.backdrop} onClick={() => setMostrarCheckList(false)}>
            <div className={styles.checklist} onClick={(e) => e.stopPropagation()}>
                <h1>Checklist</h1>
                {!isCommenting ? (
                    <div className={styles.container}>
                        <p>Taller: {formatTalleres(solicitud.taller)}</p>
                        <p>Fecha de retiro: {formatDate(solicitud.fecha_creacion)}</p>
                        <p>Hora de retiro: {formatTime(solicitud.fecha_creacion)}</p>
                        <p>Fecha de devolucion: {formatDate(solicitud.fecha_resolucion)}</p>
                        <p>Hora de devolucion: {formatTime(solicitud.fecha_resolucion)}</p>
                        <p>Ítems: {solicitud.carrito.items.length}</p>
                        <p>Descripción: {solicitud.descripcion}</p>
                        {/* Rechazar | Aceptar en una fila; Cancelar/Cerrar debajo a todo el ancho */}
                        <div className={styles.actions}>
                            {solicitud.estado === 'Recibida' ? (
                                <>
                                    <button type="button" className={styles.dangerAction} onClick={() => handleAction('reject')}>Rechazar</button>
                                    <button type="button" className={styles.primaryAction} onClick={() => handleAction('accept')}>Aceptar</button>
                                    <button type="button" className={styles.secondaryAction} onClick={() => setMostrarCheckList(false)}>Cancelar</button>
                                </>
                            ) : (
                                <button type="button" className={styles.secondaryAction} onClick={() => setMostrarCheckList(false)}>Cerrar</button>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className={styles.commentSection}>
                        <h2>{actionType === 'accept' ? 'Aceptar Solicitud' : 'Rechazar Solicitud'}</h2>
                        <textarea
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder={`Escriba un comentario antes de ${actionType === 'accept' ? 'aceptar' : 'rechazar'} (opcional)`}
                        />
                        <div className={styles.actions}>
                            <button type="button" className={styles.secondaryAction} onClick={() => setIsCommenting(false)}>Regresar</button>
                            <button
                                type="button"
                                className={actionType === 'accept' ? styles.primaryAction : styles.dangerAction}
                                onClick={submitComment}
                            >
                                {actionType === 'accept' ? 'Confirmar aceptación' : 'Confirmar rechazo'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StoreroomRequestChecklist;
